import React from 'react'
import Modal from 'react-modal'
import styles from './infoModal.scss'
import cs from 'classnames'
import nesProp from 'nested-property'

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0, left: 0, right: 0, bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
		overflow: 'auto',
        padding: '0',
        wordWrap: "break-word"
	},
}

export default class InfoModal extends React.Component {
	static propTypes = {
        isOpen: React.PropTypes.bool,
        title: React.PropTypes.string,
        content: React.PropTypes.string,
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
        cancelLabel: React.PropTypes.string,
        confirmationLabel: React.PropTypes.string,
	    options: React.PropTypes.object,
    }
    constructor(props) {
        super(props)
        //this.handleKeyPress = this.handleKeyPress.bind(this);
		this.state = {templates: null}
    }

	/* componentWillUnmount () {
		document.body.removeEventListener('keyup', this.props.onCancel, false);
	}

	handleKeyPress (evt) {
		if (vkey[evt.keyCode] === '<escape>') {
			this.props.onCancel();
		}
	}

	componentDidMount() {
        document.body.addEventListener('keyup', this.props.onCancel, false);
    } */

    render() {
        const {isOpen, onCancel, onConfirmation, cancelLabel, confirmationLabel,
            options, title, content} = this.props
        const noCancelButton = nesProp.get(options, 'noCancelButton')

		return (
            <Modal
                isOpen={isOpen}
                onCancel={onCancel}
                style={customStyles}
                className={styles.modal}
                contentLabel={""}
            >
                <div>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.contentWrapper}>
                        <div className={styles.content}>
                            {content}
                        </div>
                        <div className={styles.buttons}>

                            {!noCancelButton &&
                            <div
                                onClick={() => onCancel()}
                                className={styles.cancel}
                            >
                                {cancelLabel}
                            </div>}

                            <div
                                onClick={() => onConfirmation()}
                                className={cs(styles.next, styles.enabled)}
                            >
                                {confirmationLabel}
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
		)
	}
}



// WEBPACK FOOTER //
// ./components/generalComponents/infoModal.jsx